import authStorageConfig from './authStorageConfig'
import pushMoneyStorageConfig from './pushMoneyStorageConfig'

export const localStorageConfigs = [authStorageConfig, pushMoneyStorageConfig]

export default localStorageConfigs
